var map = {
	"./ar-MA.ts": 782,
	"./ar-SA.ts": 7732,
	"./de-DE.ts": 5159,
	"./en-KE.ts": 5520,
	"./en-NG.ts": 4719,
	"./en-US.ts": 3772,
	"./es-ES.ts": 2221,
	"./fa-IR.ts": 4765,
	"./fr-FR.ts": 1825,
	"./hi-IN.ts": 1059,
	"./it-IT.ts": 3079,
	"./ja-JP.ts": 5604,
	"./ko-KR.ts": 9570,
	"./nl-NL.ts": 4249,
	"./pt-PT.ts": 1181,
	"./ru-RU.ts": 8779,
	"./sv-SE.ts": 1818,
	"./th-TH.ts": 7021,
	"./yue-Hant-HK.ts": 879,
	"./zh-Hans-CN.ts": 6697
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8793;